module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department09-f2e535949de879cafd879a2988d9cd4f.jpg";